import { Outlet } from 'react-router';

export default function AppShell() {
  return (
    <div className="box-border h-dvh w-full bg-neutral-background-100 p-2 sm:p-3 md:p-4">
      <div className="mx-auto flex h-full w-full max-w-none flex-col overflow-hidden rounded-l bg-neutral-background-200 text-neutral-text-900">
        <div className="min-h-0 flex-1 overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
